__turbopack_context__.v({
  "background": "UEb9xa_background",
  "overlay": "UEb9xa_overlay",
  "text": "UEb9xa_text",
  "wrapper": "UEb9xa_wrapper",
});
